import { useState, useCallback } from 'react';
import { KIND } from 'baseui/notification';
import { CATEGORIES_ORDER } from './constants';
import { useSelector } from 'react-redux';
import { selectAuthData } from '@/containers/Login/AuthSelectors';
import { useTranslation } from 'react-i18next';

const useGamification = ({userAchievements}) => {
    const { t } = useTranslation('gamification');
    const isLocalOrStaging = location.hostname.includes('localhost') || location.hostname.includes('staging');
    const { authorizedSites, name, firstname } = useSelector(selectAuthData)
    const [notification, setNotification] = useState(null);
    const handleCategoryClick = useCallback(
        (category) => {
            setNotification({
                message: `${category.name} : ${category.acquired}/${category.total} ${t('netSales')}`,
                kind: category.acquired >= category.total ? KIND.positive : KIND.info,
            });
            setTimeout(() => setNotification(null), 3000);
            },
        []
    );

    const numberOfBusinessVertical = authorizedSites?.length || 0;
    const businessVerticalMap = numberOfBusinessVertical === 1 ? authorizedSites[0].business_type : 'energy';
    const categories = []
    CATEGORIES_ORDER.map((category) => {
        const snapshot = userAchievements.find((snapshot) => {
            const relatedAchievementModel = snapshot.achievement
            return relatedAchievementModel.technical_name === category.id;
        });
        if (snapshot) {
            const achievement = snapshot.achievement
            const allLevels = achievement.levels || [];
            const currentLevelOrder = snapshot.current_level?.order || 0
            const nextLevelOrderId = currentLevelOrder + 1;
            const nextLevel = allLevels.find(level => level.order === nextLevelOrderId);
            categories.push({
                id: achievement.technical_name,
                name: achievement.name, 
                acquired: snapshot.sales_count || 0,
                trophyProgressBarColor: snapshot.current_level?.icon || 'empty',
                trophyNextLevelColor: nextLevel?.icon || 'elite',
                total: nextLevel?.gap?.[businessVerticalMap] || 0,
            });
        } 
    });

    return {
        handleCategoryClick,
        notification,
        categories,
        name,
        firstname,
        isLocalOrStaging
    }
}

export default useGamification